import {EXTENSIONS as SUPPORTED_EXTENSIONS} from '@apps-common/importer';
import {Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

import DropTarget from './ui/drop-target.jsx';

const FileDrop = ({isDragging, onDragLeave, onDrop}) => {
  const {t} = useTranslation();

  return (
    <DropTarget open={isDragging} onDragLeave={onDragLeave} onDrop={onDrop}>
      <Typography variant="h4" color="white" sx={{mb: 4}}>
        {t('filedrop.title', 'Drop your file here to define area of interest')}
      </Typography>

      <Typography variant="h5" color="white" gutterBottom>
        {t('filedrop.message', 'Accepted filetypes include {{extensions}}', {
          extensions: SUPPORTED_EXTENSIONS.join(', '),
        })}
      </Typography>
    </DropTarget>
  );
};

FileDrop.propTypes = {
  isDragging: PropTypes.bool,
  onDragLeave: PropTypes.func,
  onDrop: PropTypes.func,
};

export default FileDrop;
